module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_8.049d0686.mp3";